<template>
  <v-dialog v-model="isShowModal" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">Upload Initiative</span>
      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <label class="required" for="uploadFile">
                  <strong>Select File to Upload:</strong>
                </label>
                <input
                  id="uploadFile"
                  name="uploadFile"
                  type="file"
                  @change="onFileChange"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn id="downloadBtn" name="downloadBtn" color="primary" @click.native="downloadFile">Download File</v-btn>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click.native="closeModal"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="!file"
            color="blue darken-1"
            text
            @click.native="startUploadFile"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  name: 'upload-initiative-modal',
  data() {
    return {
      file: null
    }
  },
  computed: {
    ...mapState('adminSettings', ['showUploadModal']),
    isShowModal: {
      get() {
        return this.showUploadModal
      },
      set(value) {
        this.setShowUploadModal(value)
      }
    }
  },
  methods: {
    ...mapActions('adminSettings', ['downloadFile', 'uploadFile']),
    ...mapMutations('adminSettings', ['setShowUploadModal']),
    onFileChange(e) {
      this.file = e.target.files[0]
    },
    startUploadFile() {
      this.uploadFile(this.file)
      this.closeModal()
    },
    closeModal() {
      this.file = null
      this.isShowModal = false
    }
  }
}
</script>
